<template>
   <div class="card-body" style="background-color: #f0f2f5">
     <div class="col-12 col-md-10 col-lg-11 col-xl-8 m-auto">
         <div class="card p-2">
         <div>
           <h5 class="mb-1 text-bold">{{ job.company_name }}</h5>
           <h3 class="text-primary">{{ job.title }}</h3>
         </div>

         <div class="row">
           <div class="col-6">
             <p>
               Application Deadline:
               <span class="text-danger fw-semibold">{{ job.application_deadline_format }}</span>
             </p>
           </div>
           <div class="col-6 d-flex justify-content-end align-items-start">
             <div v-if="!isLoggedIn" class="mb-3 d-flex gap-2 flex-wrap me-1">
               <button @click="openSignUpModal" class="btn btn-primary btn-sm d-sm-none">
                 Sign Up
               </button>
               <button @click="openSignUpModal" class="btn btn-primary d-none d-sm-inline-block">
                 Sign Up
               </button>
             </div>
             <div v-if="isJobApplicantUser" class="mb-3 d-flex gap-2 flex-wrap">
               <button :disabled="job.job_applied" @click="openApplyModal" class="btn btn-success">
                 {{ job.job_applied ? 'Applied' : 'Apply Now' }}
               </button>
             </div>

           </div>
         </div>

         <div class="card mb-1 border-1">
           <div class="card-body row ">
             <h3 class="text-primary">Summary</h3>
             <div class="col-md-4 col-12">Vacancy: <span class="fw-bolder">{{ job.no_of_vacancy }}</span></div>
             <div class="col-md-4 col-12" v-if="job.age_limit_from != null || job.age_remarks">
               Age:
               <span class="fw-bolder" v-if="job.age_limit_from != null">
                 {{ job.age_limit_from }} To {{ job.age_limit_to }}
               </span>
               <span v-if="job.age_remarks">
                  ({{ job.age_remarks }})
               </span>
             </div>
             <div class="col-md-4 col-12">Location: <span class="fw-bolder"> {{ job.area_name }} </span></div>
             <div class="col-md-4 col-12">
               <span v-if="job.salary_from || job.salary_remarks">
                 Salary: <span class="fw-bolder" v-if="job.salary_from"> {{ job.salary_from }} To {{ job.salary_to }}</span>
                  <span class="fw-bolder" v-else>{{ job.salary_remarks }}</span>
               </span>
               <span v-else>Salary: <span class="fw-bolder">Negotiable</span></span>
             </div>
             <div class="col-md-4 col-12" v-if="job.experience_required_from != null || job.experience_remarks">
               Experience:
               <span class="fw-bolder" v-if="job.experience_required_from != null">
                 {{ job.experience_required_from }} To {{ job.experience_required_to }}
               </span>
               <span v-if="job.experience_remarks">
                  ({{ job.experience_remarks }})
               </span>
             </div>
             <div class="col-md-4 col-12">Published: <span class="fw-bolder"> {{ job.publish_date_format }}</span></div>
           </div>
         </div>

         <div class="card border-1">
           <div class="card-body">
             <h3 class="text-primary mb-1">Requirements</h3>
             <div v-html="job.required_qualification"></div>
             <hr>

             <h3 class="text-primary mb-1">Responsibilities & Context</h3>
             <div v-html="job.key_responsibility"></div>
             <hr>

             <h3 class="text-primary mb-1">Preferred Skills & Expertise</h3>
             <div v-html="job.skills"></div>
             <hr>

             <h3 class="text-primary mb-1">General Note</h3>
             <div v-html="job.general_note"></div>
             <hr>

             <h3 class="text-primary mb-1">Employment Status</h3>
             <p>{{ job.employee_category_name }}</p>

             <h3 class="text-primary mb-1">Job Location</h3>
             <p>{{ job.area_name }}</p>

           </div>
         </div>

         <div class="card border-1">
             <div class="card-body">
               <h3 class="text-primary mb-2">Company Information</h3>
               <p>{{ job.company_name }}</p>
               <h5 class="fw-bolder">Address</h5>
               <p>{{ job.company_address }}</p>
             </div>
        </div>

       </div>
     </div>
     <authModal
         v-if="store.state.isModalOpenTwo"
     />
     <JobApplicationModal
         :job="job"
         v-if="store.state.isModalOpenThree"
         @singleJob="getJobList"
     />
   </div>

</template>

<script setup>
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import {computed, inject, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import authModal from "@/views/page/career/authModal";
import JobApplicationModal from "@/views/page/career/JobApplicationModal";

const loading = ref(false)
const job = ref({})
const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const {
  fetchSinglePostJobData
} = handleHrPayroll()
const getQuery = () => {
 return '?publish_status=publish';
}
const user = computed(() => store.state.user.user)
const isLoggedIn = computed(() => !!user.value && !!user.value.id)
const isJobApplicantUser = computed(() => !!user.value && user.value.role_name == 'job_applicant');

const openSignUpModal = () => {
    store.state.isModalOpenTwo = true;
}

const openApplyModal = () => {
  store.state.isModalOpenThree = true;
}

const getJobList = async () => {
  const query = getQuery();
  loading.value = true
  job.value = {};
  let jobPostSlug = route.params.jobPostSlug

  await fetchSinglePostJobData(jobPostSlug, query).then(res => {
    if (!res.status){
      return
    }
    job.value = res.data;
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

onMounted(() => {
  Promise.all([
    getJobList(),
  ])
})
</script>

<style scoped>


</style>
